import { Dispatch } from "react";

interface BankAction {
  type: "UPDATE_BANK";
  name: string | null;
}
export const updateBank =
  (name: string | null) => async (dispatch: Dispatch<BankAction>) => {
    dispatch({
      type: "UPDATE_BANK",
      name,
    });
  };
